import InvitationsContainer from './InvitationsContainer';


export default InvitationsContainer;